<template>
  <div :id="`vendor-share-card-${detail.checklistRequestedId}`" class="tw-flex">
    <div
      :class="[
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        classStyleContent,
      ]"
    >
      <div class="tw-flex tw-flex-col tw-w-full tw-gap-[10px]">
        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`"
          >
            {{
              getComponentUiText(
                "app-component-assessments-vendor-assessment-share-card-shared-title-1",
              )
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            :id="`vendor-progress-card-last-updated-${detail.checklistRequestedId}`"
            class="tw-text-[#878787] tw-text-[13px] tw-font-[400]"
          >
            {{ getLastUpdatedTimeFromNow() }}
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title tw-w-[85px]`"
          >
            {{
              getComponentUiText(
                "app-component-assessments-vendor-assessment-share-card-shared-with-title-1",
              )
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title tw-overflow-hidden tw-flex-1"
            @mouseover="isHoverShared = true"
            @mouseleave="isHoverShared = false"
          >
            <p
              :id="`vendor-progress-card-email-${detail.checklistRequestedId}`"
              :data-cy="`vendor-progress-card-email-${detail.checklistRequestedId}`"
              :class="`${
                isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#387DFF]'
              } tw-text-[13px] tw-font-[400] share-email`"
            >
              {{
                !isGreyOut &&
                isHoverShared &&
                (dataEmailGrant.firstName || dataEmailGrant.lastName)
                  ? (dataEmailGrant.firstName ? dataEmailGrant.firstName : "") +
                    " " +
                    (dataEmailGrant.lastName ? dataEmailGrant.lastName : "")
                  : dataEmailGrant?.recipientEmail ?? "-"
              }}
            </p>
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            :class="`${
              isGreyOut ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`"
          >
            {{
              getComponentUiText(
                "app-component-assessments-vendor-assessment-share-card-expiry-date-title-1",
              )
            }}
          </div>
          <div
            v-if="loading"
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            :id="`vendor-progress-card-expiry-date-${detail.checklistRequestedId}`"
            :data-cy="`vendor-progress-card-expiry-date-${detail.checklistRequestedId}`"
            class="tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-cursor-pointer"
            @mouseover="isHoverExpiryDate = true"
            @mouseleave="isHoverExpiryDate = false"
          >
            {{
              dataEmailGrant?.validUntil
                ? isHoverExpiryDate
                  ? dayjs(dataEmailGrant?.validUntil)
                      .locale(getLocale())
                      .format("DD MMM YYYY")
                  : getNextDay(new Date(dataEmailGrant?.validUntil))
                : "-"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText, getNextDay } from "@/utils/utilities";
import { ComputedRef, PropType, computed, ref } from "vue";
import { getLocale, getTimeFromNow } from "@/utils/dateTimeUtils";
import { IChecklistRequested, IDataEmailGrant } from "@/interfaces/vendor";
import dayjs from "dayjs";

const props = defineProps({
  detail: {
    type: Object as PropType<IChecklistRequested>,
    default: {} as IChecklistRequested,
    required: false,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
  dataEmailGrant: {
    type: Object as PropType<IDataEmailGrant>,
    default: {} as IDataEmailGrant,
    require: false,
  },
});

const dataEmailGrant: ComputedRef<any> = computed(() => {
  return props.detail?.dataEmailGrant || props?.dataEmailGrant;
});

const isGreyOut: ComputedRef<any> = computed(() => {
  return props.detail?.isArchived;
});
const isHoverExpiryDate = ref(false);
const isHoverShared = ref(false);

const getLastUpdatedTimeFromNow = () => {
  if (!dataEmailGrant.value?.dateEmailSent) return "-";
  return getTimeFromNow(dataEmailGrant.value?.dateEmailSent);
};
</script>
<style>
.share-email {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: right;
  margin: 0;
}
</style>
